/* ============================================================
   ALIFBETE — product card image cycle + hover arrows
   Approach: reads image URLs from Horizon's existing slides,
   creates a separate overlay layer on top with cloned images,
   crossfades them every 4s. Does NOT modify Horizon's DOM.
   ============================================================ */
(function () {
  'use strict';
  var CYCLE_MS = 4000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function injectStyles() {
    if (document.getElementById('alifbete-cycle-styles')) return;
    var style = document.createElement('style');
    style.id = 'alifbete-cycle-styles';
    style.textContent = [
      '.alifbete-img-layer{position:absolute;inset:0;z-index:3;pointer-events:none;overflow:hidden;}',
      '.alifbete-img-frame{position:absolute;inset:0;opacity:0;transition:opacity 0.6s ease;display:flex;align-items:center;justify-content:center;background:#fff;}',
      '.alifbete-img-frame img{width:100%;height:100%;object-fit:contain;}',
      '.alifbete-img-arrow{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;background:rgba(8,10,14,0.78);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);border:1px solid rgba(255,255,255,0.2);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;transition:opacity 0.2s,background 0.2s;z-index:10;pointer-events:auto;padding:0;}',
      '.alifbete-img-arrow--prev{left:8px;}',
      '.alifbete-img-arrow--next{right:8px;}',
      '.alifbete-img-arrow:hover{background:#e63946;border-color:#e63946;}',
      'product-card:hover .alifbete-img-arrow,[class*="product-card"]:hover .alifbete-img-arrow{opacity:1;}',
      '@media (max-width:749px){.alifbete-img-arrow{opacity:1;width:30px;height:30px;}}',
      'product-card slideshow-control,product-card slideshow-arrows,[class*="product-card"] slideshow-control,[class*="product-card"] slideshow-arrows{display:none !important;}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  }

  function getImageUrls(card) {
    var imgs = card.querySelectorAll('.card-gallery img');
    var urls = [];
    var seen = {};
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
      if (!src && img.srcset) {
        var first = img.srcset.split(',')[0];
        if (first) src = first.trim().split(/\s+/)[0];
      }
      if (!src) continue;
      if (src.indexOf('data:image/svg') === 0) continue;
      if (src.indexOf('data:') === 0) continue;
      var normalized = src.split('?')[0];
      if (seen[normalized]) continue;
      seen[normalized] = true;
      urls.push(src);
    }
    return urls;
  }

  function initCard(card) {
    if (card.__alifbeteCycleOk) return;
    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return;

    var urls = getImageUrls(card);
    if (urls.length < 2) return; // don't flag, allow retry when more imgs load

    card.__alifbeteCycleOk = true;

    // Make gallery a positioning context
    var computedPos = window.getComputedStyle(gallery).position;
    if (computedPos === 'static') gallery.style.position = 'relative';

    // Build overlay layer
    var layer = document.createElement('div');
    layer.className = 'alifbete-img-layer';

    var frames = [];
    for (var i = 0; i < urls.length; i++) {
      var frame = document.createElement('div');
      frame.className = 'alifbete-img-frame';
      if (i === 0) frame.style.opacity = '1';
      var img = document.createElement('img');
      img.src = urls[i];
      img.alt = '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      frame.appendChild(img);
      layer.appendChild(frame);
      frames.push(frame);
    }
    gallery.appendChild(layer);

    var idx = 0;
    var timer = null;

    function show(n) {
      var prev = idx;
      idx = ((n % frames.length) + frames.length) % frames.length;
      if (prev === idx) return;
      frames[prev].style.opacity = '0';
      frames[idx].style.opacity = '1';
    }
    function start() {
      if (reduce) return;
      stop();
      timer = setInterval(function () { show(idx + 1); }, CYCLE_MS);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Arrows
    var prevBtn = document.createElement('button');
    var nextBtn = document.createElement('button');
    prevBtn.type = 'button';
    nextBtn.type = 'button';
    prevBtn.className = 'alifbete-img-arrow alifbete-img-arrow--prev';
    nextBtn.className = 'alifbete-img-arrow alifbete-img-arrow--next';
    prevBtn.setAttribute('aria-label', 'Previous image');
    nextBtn.setAttribute('aria-label', 'Next image');
    prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    function killEvent(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    function onPrev(e) { killEvent(e); show(idx - 1); start(); return false; }
    function onNext(e) { killEvent(e); show(idx + 1); start(); return false; }

    // Use capture phase to beat the wrapping product link
    prevBtn.addEventListener('click', onPrev, true);
    nextBtn.addEventListener('click', onNext, true);
    prevBtn.addEventListener('mousedown', function(e){ e.stopPropagation(); }, true);
    nextBtn.addEventListener('mousedown', function(e){ e.stopPropagation(); }, true);
    prevBtn.addEventListener('pointerdown', function(e){ e.stopPropagation(); }, true);
    nextBtn.addEventListener('pointerdown', function(e){ e.stopPropagation(); }, true);

    layer.appendChild(prevBtn);
    layer.appendChild(nextBtn);

    setTimeout(start, Math.random() * 1500);
    card.addEventListener('mouseenter', stop);
    card.addEventListener('mouseleave', start);
  }

  function boot() {
    var cards = document.querySelectorAll('product-card, [class*="product-card"]');
    Array.prototype.forEach.call(cards, initCard);
  }

  function go() { injectStyles(); boot(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else {
    go();
  }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
  // Late retries for cards whose images load after first boot
  setTimeout(boot, 1500);
  setTimeout(boot, 3000);
})();
